import Loadable from "../../../components/Loadable";

const DetilTatib = Loadable(() => import("./Detil"));
const MasukanTatib = Loadable(() => import("./Masukan"));
const RekapitulasiTatib = Loadable(() => import("./Rekapitulasi"));

const GuruMasukanTatib = Loadable(() => import("./Guru/Masukan"));
const GuruRekapitulasiTatib = Loadable(() => import("./Guru/Rekapitulasi"));

const view = {
  DetilTatib,
  MasukanTatib,
  RekapitulasiTatib,

  GuruMasukanTatib,
  GuruRekapitulasiTatib,
};

export default view;
